import { Button, typographyStyle } from '@revenuemarket/cds';
import KakaoLogo from '@revenuemarket/cds/components/Icon/KakaoLogo';

import { OAuthProviderType } from '~apis/auth/maybeSignInWithOAuth';
import { getOauthRedirectUrl } from '~components/Auth/Signin/utils';
import { OAUTH_AUTH_DOMAIN } from '~constants/env';
import { css } from '~libs/emotion';

const KakaoLoginButton = ({
  title,
  onKakaoOauthClick,
}: {
  title: string;
  onKakaoOauthClick?: () => void;
}) => {
  const handleClick = () => {
    onKakaoOauthClick?.();

    // finance.cloud 도메인에서는 OAUTH_AUTH_DOMAIN으로 먼저 이동
    if (typeof window !== 'undefined' && window.location.hostname.endsWith('.finance.cloud')) {
      const currentOrigin = window.location.origin;
      const encodedOrigin = encodeURIComponent(currentOrigin);
      const randomState = Math.random().toString(36).substring(2) + Date.now().toString(36);
      window.location.href = `${OAUTH_AUTH_DOMAIN}/oauth/init?provider=kakao&origin=${encodedOrigin}&state=${randomState}`;
      return;
    }

    // 기존 로직: clobe.ai 도메인은 직접 Kakao SDK 사용
    if (window.Kakao) {
      if (!window.Kakao.isInitialized()) {
        window.Kakao.init(process.env.KAKAO_APP_KEY);
      }

      window.Kakao.Auth.authorize({
        redirectUri: getOauthRedirectUrl(OAuthProviderType.KAKAO),
      });
    }
  };

  return (
    <Button
      onClick={handleClick}
      buttonType="default"
      buttonSize="xlarge"
      style={{
        ...typographyStyle['16_500'],
      }}
      className={css`
        border-color: #fee500;
        background-color: #fee500;
        color: #000000d9;

        &:hover {
          border-color: #eed703;
          background-color: #eed703;
        }
      `}
      icon={<KakaoLogo />}
    >
      {title}
    </Button>
  );
};

export default KakaoLoginButton;
